import styled from 'styled-components';

const FlexBox = styled.div`
display: flex;
flex-direction: ${(props) => props.direction ? props.direction : 'row'};
flex-wrap: ${(props) => props.wrap ? props.wrap : 'wrap'};
justify-content: ${(props) => props.justifyContent ? props.justifyContent : 'flex-start'};
align-items: ${(props) => props.alignItems ? props.alignItems : 'stretch'};
`;

export default FlexBox;



// WEBPACK FOOTER //
// ./app/components/FlexBox/index.js